import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'clsx';
import React from 'react';
import { device } from '~/utils';

class ButtonCopyLink extends React.Component {
  state = {
    showCopySuccess: false,
    link: '',
  };

  componentDidMount() {
    this.setState({
      link: window.location.href,
    });
  }

  handleCopy = () => {
    this.setState({ showCopySuccess: true });
    const text = window.location.href;
    if (window.navigator && window.navigator.clipboard) {
      navigator.clipboard.writeText(text);
    } else {
      device.copyToClipboard(text);
    }
  };

  render() {
    const { showCopySuccess } = this.state;
    const { t, className } = this.props;
    const buttonClassName = classNames('btn-copy-link');

    return (
      <div className="container-button-copy">
        <div className={buttonClassName} onClick={this.handleCopy}>
          <FontAwesomeIcon
            icon={showCopySuccess ? faCheck : faCopy}
            className="icon-copy"
            style={{ width: '1em', marginRight: 4 }}
          />
          {t('copy_link')}
        </div>
        <style jsx>
          {`
            .container-button-copy {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
            }
            .btn-copy-link {
              display: flex;
              align-items: center;
              justify-content: center;
              background: #170507;
              border-radius: 40px;
              color: #f8f9fa;
              height: 32px;
              cursor: pointer;
              padding: 0 16px;
            }
            .link-photo {
              width: calc(100% - 124px);
              background: #f8f9fa;
              margin-right: 4px;
              border: 1px solid #1b2833;
              border-radius: 4px;
            }
          `}
        </style>
      </div>
    );
  }
}
export default ButtonCopyLink;
